import React, { useState } from "react";
import { FaSortUp } from "react-icons/fa6";
import RepairCreditCard from "./RepairAccountsCard";

const RepairAccountsData = ({ selectedCardState, onCardSelect }) => {
  // State to manage visibility of the extra rows
  const [showMore, setShowMore] = useState(false);

  const cardData = [
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    // Repeat for all 9 cards
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",
      btn_text: "Negative",
      desc: "ALLIANCE ONE",
      icons: <FaSortUp />,
      status: "TransUnion",
    },
  ];

  // Get the first 6 cards for default view
  const defaultCards = cardData.slice(0, 9);
  // Get the extra 3 cards to show on "View More"
  const extraCards = cardData.slice(6);

  return (
    <div className="row">
      {/* Default 6 cards */}
      {defaultCards.map((card, index) => (
        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
          <RepairCreditCard
            title={card.title}
            btn_text={card.btn_text}
            desc={card.desc}
            icons={card.icons}
            status={card.status}
            onCardSelect={onCardSelect}
            onSelect={(isChecked) => onCardSelect(index, isChecked)}
          />
        </div>
      ))}

      {/* Show more cards if "View More" is clicked */}
      {showMore &&
        extraCards.map((card, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index + 6}>
            <RepairCreditCard
              title={card.title}
              btn_text={card.btn_text}
              desc={card.desc}
              icons={card.icons}
              status={card.status}
              onCardSelect={onCardSelect}
              onSelect={(isChecked) => onCardSelect(index, isChecked)}
            />
          </div>
        ))}

      {/* Button to toggle "View More" */}
      <div className="view_btn mt-4">
        <button className="btn btn_s" onClick={() => setShowMore(!showMore)}>
          {showMore ? "View Less" : "View More"}
        </button>
      </div>
    </div>
  );
};

export default RepairAccountsData;
